import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { Switch } from '@/components/ui/switch';
import { Label } from '@/components/ui/label';
import { useTOTP } from 'src/containers/TOTP';
import { Skeleton } from '@/components/ui/skeleton';

const ProfileTOTPContainer = () => {
  const { isTOTPEnabled, enableTOTP, showDisableAlert, isLoading } = useTOTP();

  const onChange = (checked: boolean) => {
    if (checked) {
      enableTOTP();
    } else {
      showDisableAlert();
    }
  };

  return (
    <Card>
      <CardHeader>
        <CardTitle className="text-lg">Multi-factor authentication</CardTitle>
        <CardDescription>Enable or disable multi-factor authentication for your account.</CardDescription>
      </CardHeader>
      <CardContent>
        {isLoading ? (
          <Skeleton className="h-[20px] w-30" />
        ) : (
          <div className="flex items-center space-x-2">
            <Switch id="mfa" checked={isTOTPEnabled} onCheckedChange={onChange} />
            <Label htmlFor="mfa" className="mb-0">
              MFA {isTOTPEnabled ? 'enabled' : 'disabled'}
            </Label>
          </div>
        )}
      </CardContent>
    </Card>
  );
};

export default ProfileTOTPContainer;
